export default {
    countries: [],
    IsBookingNoRegistration: false,
    // learningInfo: [],
    isSettingsNoRegistration: false,
}
